import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  familyMemberAdapter,
  FamilyMemberState,
} from '../reducers/family.reducer';
import { OwnerState } from '../reducers/owner.reducer';
import { ownerState } from './owner.selector';
import { state } from '@angular/animations';

export const familySelector =
  createFeatureSelector<FamilyMemberState>('familyMembers');

export const selectAllFamilyMembers = createSelector(
  familySelector,
  (state) =>
    familyMemberAdapter
      .getSelectors()
      .selectAll(state)
      // .filter((member: any) => !member?.deleted_at)
);
// export const selectAllFamilyMembersWithTrashedValues = createSelector(
//   familySelector,
//   (state) =>
//     familyMemberAdapter
//       .getSelectors()
//       .selectAll(state)
// );

export const selectEmployeesFamilyMembers = createSelector(
  familySelector,
  (familyMember) =>
    Array.from(Object.values(familyMember.entities)).filter(
      (x) => x?.id
    )
);

export const selectEmployees = createSelector(
  selectEmployeesFamilyMembers,
  ownerState,
  (familyState, ownerState) => {
    let Employees = [];
    familyState.forEach((val) => { if (val?.employee) Employees.push(val?.employee) });
    if (ownerState?.employee) Employees.push(ownerState.employee);
    return Employees;
  }
);

export const selectFamilyMemberById = (id: number) =>
  createSelector(familySelector, (allItems: any) => {
    if (allItems?.entities[id]) {
      return allItems?.entities[id];
    } else {
      return null;
    }
  });
